import { IDeleteHabilidadeUseCase } from "../../../presentation/useCases/delete/delete_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteHabilidadeUseCase
 */

export class DeleteHabilidadeUseCase implements IDeleteHabilidadeUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteHabilidade(
    idHabilidade: number
  ): Promise<void> {
    await this.repository.deleteHabilidade(idHabilidade);
  }
}
